export default "/images/vendor/flag-icon-css/flags/1x1/gw.svg?a27c290b1227336d0a32c14c6df479d7";